// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Logo_wrapper__3QNFm","text":"Logo_text__3A0i_"};